import { DocSearch } from "@docsearch/react";

import "@docsearch/css";
import "./App.css";
import "./fragments.css";
import { useState, useRef, useEffect } from "react";
import type {
  InternalDocSearchHit,
  StoredDocSearchHit,
} from "@docsearch/react/dist/esm/types";

const App = () => {
  const [itemUrl, setItemUrl] = useState<string>("https://atproto.com/docs");
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (!iframeRef.current) return;
    const iframe = iframeRef.current;

    iframe.src = itemUrl;
    iframe.src = iframe.src;
  }, [itemUrl]);

  useEffect(() => {
    const links = document.querySelectorAll(".DocSearch-Hit a");

    links.forEach((link) => {
      const href = link.getAttribute("href");
      if (!href) return;

      link.removeAttribute("href");
      link.setAttribute("data-href", href);

      link.addEventListener("click", (e) => {
        e.preventDefault();
        const href = link.getAttribute("href");
        if (!href) return;
        setItemUrl(href);
      });
    });
  }, []);

  const addHighlightFragment = (url: string, term: string) => {
    // Sanitize search term for use in URL fragment
    let sanitizedTerm = encodeURIComponent(term);
    // Create highlight fragment
    let highlightFragment = "#:~:text=" + sanitizedTerm;
    // Replace existing fragment or add new fragment
    if (url.indexOf("#") > -1) {
      url = url.replace(/#.*$/, highlightFragment);
    } else {
      url += highlightFragment;
    }
    return url;
  };

  const handleClick = (
    hit: InternalDocSearchHit | StoredDocSearchHit | any
  ) => {
    let url = hit.url;

    // var highlightedValue =
    //   hit._snippetResult && hit._snippetResult.content
    //     ? hit._snippetResult.content.value
    //     : hit.content || hit.url;

    // // Remove <mark> and </mark> tags from highlightedValue
    // highlightedValue = highlightedValue.replace(/<\/?mark>/g, "");
    // // Remove "… " & " …"from the sring if it exists
    // highlightedValue = highlightedValue.replace(/… ?| ?…/g, "");

    // // Remove last space from the string if it exists
    // highlightedValue = highlightedValue.replace(/ $/, "");
    // // Remove last dot from the string if it exists
    // highlightedValue = highlightedValue.replace(/\.$/, "");

    // console.log(highlightedValue);
    // url = addHighlightFragment(url, highlightedValue);

    // console.log(url);

    setItemUrl(url);
  };

  return (
    <>
      <nav style={{ position: "relative" }}>
        <div className="w-100p h-90 d-flex ai-center jc-start ph-1d5e">
          <div>
            <a href="/">
              <span className="d-none">ATP</span>
              <img className="w-auto h-40" src="./logo.jpg" alt="" />
            </a>
          </div>
          <div className="sm:d-none">
            <button
              id="headlessui-popover-button-:R16:"
              type="button"
              aria-expanded="false"
              data-headlessui-state=""
            >
              <span className="sr-only">Open menu</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                className="h-6 w-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                ></path>
              </svg>
            </button>
          </div>
          <nav className="sm:d-flex fxg-1 jc-start ml-2d5e">
            <a title="Developers" href="/docs">
              Developers
            </a>

            <span id="search" className="ml-1d5e">
              <DocSearch
                appId={process.env.REACT_APP_ALGOLIA_APP_ID!}
                indexName={process.env.REACT_APP_ALGOLIA_INDEX_NAME!}
                apiKey={process.env.REACT_APP_ALGOLIA_SEARCH_KEY!}
                navigator={{
                  navigate({ itemUrl }) {
                    setItemUrl(itemUrl);
                  },
                }}
                hitComponent={({ hit, children }) => {
                  //console.log(hit);
                  return (
                    <a
                      data-url={hit.url}
                      onClick={() =>
                        handleClick(
                          hit
                          // hit.url,
                          // hit.hierarchy.lvl0 ? hit.hierarchy.lvl0 : ""
                        )
                      }
                    >
                      {children}
                    </a>
                  );
                }}
                getMissingResultsUrl={({ query }) => {
                  return `https://github.com/bluesky-social/atproto/issues/new?title=${query}`;
                }}
              />
            </span>
          </nav>
          <div className="d-flex ai-center jc-end">
            <a
              title="Twitter"
              className="ml-1d5e"
              href="https://twitter.com/bluesky"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="twitter"
                className="svg-inline--fa fa-twitter h-6 w-6"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                ></path>
              </svg>
            </a>
            <a
              title="GitHub"
              className="ml-1d5e"
              href="https://github.com/bluesky-social"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="github"
                className="svg-inline--fa fa-github h-6 w-6"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 496 512"
              >
                <path
                  fill="currentColor"
                  d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </nav>

      {/* Iframe */}
      {itemUrl && (
        <iframe
          src={itemUrl}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            border: "none",
          }}
          ref={iframeRef}
        ></iframe>
      )}
    </>
  );
};

export default App;
